/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../app/browser-app.module';
import * as import2 from '../../modules/transfer-state/browser-transfer-state.module';
import * as import3 from '@angular/common';
import * as import4 from '@angular/router';
import * as import5 from '@angular/platform-browser';
import * as import6 from '@angular/platform-browser/animations';
import * as import7 from '@angular/http';
import * as import8 from '../../app/shared/sdk/index';
import * as import9 from '@angular/forms';
import * as import10 from '../../modules/transfer-http/transfer-http.module';
import * as import11 from '../../app/app-routing.module';
import * as import12 from '../../app/shared/login/login.module';
import * as import13 from '../../app/shared/social-share/social-share.module';
import * as import14 from '../../app/shared/decorator/decorator.module';
import * as import15 from '../../app/shared/comments/disqus.module';
import * as import16 from '../../app/shared/sticky-header/sticky-header.module';
import * as import17 from 'angular2-infinite-scroll/src/index';
import * as import18 from '../../app/shared/subscribe/subscribe.module';
import * as import19 from '../../app/shared/pipes/unescape-cache-pipe';
import * as import20 from '../../app/category/section/section-category.module';
import * as import21 from 'ng2-nouislider/src/nouislider';
import * as import22 from '../../app/app.module';
import * as import23 from '../../app/shared/sdk/services/core/error.service';
import * as import24 from '../../app/shared/sdk/sockets/socket.browser';
import * as import25 from '../../app/shared/sdk/sockets/socket.connections';
import * as import26 from '../../modules/transfer-http/transfer-http';
import * as import27 from '../../app/shared/sdk/services/custom/SDKModels';
import * as import28 from '../../app/shared/sdk/storage/cookie.browser';
import * as import29 from '../../app/shared/sdk/services/core/auth.service';
import * as import30 from '../../app/shared/sdk/services/core/search.params';
import * as import31 from '../../app/shared/sdk/services/custom/AppUser';
import * as import32 from '../../app/shared/login/common/auth.service';
import * as import33 from 'angular2-infinite-scroll/src/axis-resolver';
import * as import34 from 'angular2-infinite-scroll/src/position-resolver';
import * as import35 from 'angular2-infinite-scroll/src/scroll-register';
import * as import36 from 'angular2-infinite-scroll/src/scroll-resolver';
import * as import37 from '../../app/shared/sdk/services/custom/Page';
import * as import38 from '../../app/shared/sdk/services/custom/Article';
import * as import39 from '../../app/shared/services/stringutils';
import * as import40 from '../../../common/utils/articleutils';
import * as import41 from '../../app/shared/sdk/services/custom/CostGuide';
import * as import42 from '../../app/shared/sdk/services/custom/Category';
import * as import43 from '../../app/shared/sdk/services/custom/ZipcodeModificationFactor';
import * as import44 from '../../../common/utils/costguideutils';
import * as import45 from '../../app/shared/type-builder/type.builder';
import * as import46 from '../../app/shared/animations/hero-animation.service';
import * as import47 from '../../app/shared/sdk/services/custom/City';
import * as import48 from '../../../common/utils/cityutils';
import * as import49 from '../../app/shared/sdk/services/custom/ProfessionCategory';
import * as import50 from '../../../common/utils/professioncategoriesutils';
import * as import51 from '../../../common/utils/mapurlutils';
import * as import52 from '../../../common/utils/censustractstilesutils';
import * as import53 from '../../app/shared/sdk/services/custom/CostsOfLiving';
import * as import54 from '../../../common/utils/costoflivingutils';
import * as import55 from '../../app/shared/sdk/services/custom/Taxes';
import * as import56 from '../../../common/utils/taxesutils';
import * as import57 from '../../../common/utils/affordabilityutils';
import * as import58 from '../../app/shared/services/aot2jitsharing.service';
import * as import59 from '../../app/shared/sdk/services/custom/logger.service';
import * as import60 from '../../app/shared/sdk/services/core/real.time';
import * as import61 from '../../app/shared/sdk/services/custom/FixrAPI';
import * as import62 from '../../app/shared/sdk/services/custom/ProfessionAnnualWagesIndex';
import * as import63 from '../../app/shared/sdk/services/custom/Job';
import * as import64 from '../../app/shared/sdk/services/custom/TaxSim';
import * as import65 from '../../app/shared/sdk/storage/storage.browser';
import * as import66 from './home/home.component.ngfactory';
import * as import67 from './cost-guide/cost-guide-list/cost-guide-list.component.ngfactory';
import * as import68 from './cost-guide/cost-guide-page/cost-guide.component.ngfactory';
import * as import69 from './article/article.component.ngfactory';
import * as import70 from './category/category.component.ngfactory';
import * as import71 from './lead-form/questionnaire-form/questionnaire-form.component.ngfactory';
import * as import72 from './lead-form/successpage/successpage.component.ngfactory';
import * as import73 from './about-us/about-us.component.ngfactory';
import * as import74 from './cost-of-living/cost-of-living.component.ngfactory';
import * as import75 from './app.component.ngfactory';
import * as import76 from '../../app/home/home.component';
import * as import77 from '../../app/cost-guide/cost-guide-list/cost-guide-list.component';
import * as import78 from '../../app/cost-guide/cost-guide-page/cost-guide.component';
import * as import79 from '../../app/article/article.component';
import * as import80 from '../../app/category/category.component';
import * as import81 from '../../app/lead-form/questionnaire-form/questionnaire-form.component';
import * as import82 from '../../app/lead-form/successpage/successpage.component';
import * as import83 from '../../app/about-us/about-us.component';
import * as import84 from '../../app/cost-of-living/cost-of-living.component';
import * as import85 from '../../modules/transfer-state/transfer-state';
import * as import86 from '@angular/animations/browser';
import * as import87 from '../../app/shared/sdk/sockets/socket.driver';
import * as import88 from '../../app/shared/sdk/storage/storage.swaps';
class BrowserAppModuleInjector extends import0.ɵNgModuleInjector<import1.BrowserAppModule> {
  _BrowserTransferStateModule_0:import2.BrowserTransferStateModule;
  _CommonModule_1:import3.CommonModule;
  _ErrorHandler_2:any;
  _NgProbeToken_3:any[];
  _ɵg_4:import4.ɵg;
  _APP_ID_5:any;
  _ɵTRANSITION_ID_6:any;
  _APP_INITIALIZER_7:any[];
  _ApplicationInitStatus_8:import0.ApplicationInitStatus;
  _ɵf_9:import0.ɵf;
  _ApplicationRef_10:any;
  _ApplicationModule_11:import0.ApplicationModule;
  _BrowserModule_12:import5.BrowserModule;
  _BrowserAnimationsModule_13:import6.BrowserAnimationsModule;
  _HttpModule_14:import7.HttpModule;
  _SDKBrowserModule_15:import8.SDKBrowserModule;
  _ɵba_16:import9.ɵba;
  _FormsModule_17:import9.FormsModule;
  _ReactiveFormsModule_18:import9.ReactiveFormsModule;
  _TransferHttpModule_19:import10.TransferHttpModule;
  _ɵa_20:any;
  _UrlSerializer_21:import4.DefaultUrlSerializer;
  _RouterOutletMap_22:import4.RouterOutletMap;
  _ROUTER_CONFIGURATION_23:any;
  _LocationStrategy_24:any;
  _Location_25:import3.Location;
  _Compiler_26:import0.Compiler;
  _NgModuleFactoryLoader_27:import0.SystemJsNgModuleLoader;
  _ROUTES_28:any[];
  _Router_29:any;
  _RouterModule_30:import4.RouterModule;
  _AppRoutingModule_31:import11.AppRoutingModule;
  _LoginModule_32:import12.LoginModule;
  _SocialShareModule_33:import13.SocialShareModule;
  _DecoratorModule_34:import14.DecoratorModule;
  _DisqusModule_35:import15.DisqusModule;
  _StickyHeaderModule_36:import16.StickyHeaderModule;
  _InfiniteScrollModule_37:import17.InfiniteScrollModule;
  _SubscribeModule_38:import18.SubscribeModule;
  _UnescapeCachePipeModule_39:import19.UnescapeCachePipeModule;
  _SectionCategoryModule_40:import20.SectionCategoryModule;
  _NouisliderModule_41:import21.NouisliderModule;
  _AppModule_42:import22.AppModule;
  _BrowserAppModule_43:import1.BrowserAppModule;
  __TransferState_44:any;
  __LOCALE_ID_45:any;
  __NgLocalization_46:import3.NgLocaleLocalization;
  __IterableDiffers_47:any;
  __KeyValueDiffers_48:any;
  __DomSanitizer_49:import5.ɵe;
  __Sanitizer_50:any;
  __HAMMER_GESTURE_CONFIG_51:import5.HammerGestureConfig;
  __EVENT_MANAGER_PLUGINS_52:any[];
  __EventManager_53:import5.EventManager;
  __ɵDomSharedStylesHost_54:import5.ɵDomSharedStylesHost;
  __ɵDomRendererFactory2_55:import5.ɵDomRendererFactory2;
  __AnimationDriver_56:any;
  __ɵAnimationStyleNormalizer_57:any;
  __ɵAnimationEngine_58:import6.ɵa;
  __RendererFactory2_59:any;
  __ɵSharedStylesHost_60:any;
  __Testability_61:import0.Testability;
  __Meta_62:import5.Meta;
  __Title_63:import5.Title;
  __BrowserXhr_64:import7.BrowserXhr;
  __ResponseOptions_65:import7.BaseResponseOptions;
  __XSRFStrategy_66:any;
  __XHRBackend_67:import7.XHRBackend;
  __RequestOptions_68:import7.BaseRequestOptions;
  __Http_69:any;
  __ErrorHandler_70:import23.ErrorHandler;
  __SocketDriver_71:import24.SocketBrowser;
  __SocketConnection_72:import25.SocketConnection;
  __ɵi_73:import9.ɵi;
  __FormBuilder_74:import9.FormBuilder;
  __TransferHttp_75:import26.TransferHttp;
  __ActivatedRoute_76:any;
  __NoPreloading_77:import4.NoPreloading;
  __PreloadingStrategy_78:any;
  __RouterPreloader_79:import4.RouterPreloader;
  __PreloadAllModules_80:import4.PreloadAllModules;
  __ROUTER_INITIALIZER_81:any;
  __APP_BOOTSTRAP_LISTENER_82:any[];
  __SDKModels_83:import27.SDKModels;
  __InternalStorage_84:import28.CookieBrowser;
  __LoopBackAuth_85:import29.LoopBackAuth;
  __JSONSearchParams_86:import30.JSONSearchParams;
  __AppUserApi_87:import31.AppUserApi;
  __AuthService_88:import32.AuthService;
  __AxisResolverFactory_89:import33.AxisResolverFactory;
  __PositionResolverFactory_90:import34.PositionResolverFactory;
  __ScrollRegister_91:import35.ScrollRegister;
  __ScrollResolver_92:import36.ScrollResolver;
  __PageApi_93:import37.PageApi;
  __ArticleApi_94:import38.ArticleApi;
  __StringUtils_95:import39.StringUtils;
  __ArticleUtils_96:import40.ArticleUtils;
  __CostGuideApi_97:import41.CostGuideApi;
  __CategoryApi_98:import42.CategoryApi;
  __ZipcodeModificationFactorApi_99:import43.ZipcodeModificationFactorApi;
  __CostGuideUtils_100:import44.CostGuideUtils;
  __DynamicTypeBuilder_101:import45.DynamicTypeBuilder;
  _isBrowser_102:any;
  __HeroAnimationService_103:import46.HeroAnimationService;
  __CityApi_104:import47.CityApi;
  __CityUtils_105:import48.CityUtils;
  __ProfessionCategoryApi_106:import49.ProfessionCategoryApi;
  __ProfessionCategoriesUtils_107:import50.ProfessionCategoriesUtils;
  __MapUrlUtils_108:import51.MapUrlUtils;
  __CensusTractsTilesUtils_109:import52.CensusTractsTilesUtils;
  __CostsOfLivingApi_110:import53.CostsOfLivingApi;
  __CostOfLivingUtils_111:import54.CostOfLivingUtils;
  __TaxesApi_112:import55.TaxesApi;
  __TaxesUtils_113:import56.TaxesUtils;
  __AffordabilityUtils_114:import57.AffordabilityUtils;
  __Aot2JitSharingService_115:import58.Aot2JitSharingService;
  __LoggerService_116:import59.LoggerService;
  __RealTime_117:import60.RealTime;
  __FixrAPIApi_118:import61.FixrAPIApi;
  __ProfessionAnnualWagesIndexApi_119:import62.ProfessionAnnualWagesIndexApi;
  __JobApi_120:import63.JobApi;
  __TaxSimApi_121:import64.TaxSimApi;
  __SDKStorage_122:import65.StorageBrowser;
  _isNode_123:any;
  constructor(parent:import0.Injector) {
    super(parent,[
      import66.HomeComponentNgFactory,
      import67.CostGuideListComponentNgFactory,
      import68.CostGuideComponentNgFactory,
      import69.ArticleComponentNgFactory,
      import70.CategoryComponentNgFactory,
      import71.QuestionnaireFormComponentNgFactory,
      import72.SuccessPageComponentNgFactory,
      import73.AboutUsComponentNgFactory,
      import74.CostOfLivingComponentNgFactory,
      import75.AppComponentNgFactory
    ]
    ,[import75.AppComponentNgFactory]);
  }
  get _TransferState_44():any {
    if ((this.__TransferState_44 == null)) { (this.__TransferState_44 = import2.getTransferState()); }
    return this.__TransferState_44;
  }
  get _LOCALE_ID_45():any {
    if ((this.__LOCALE_ID_45 == null)) { (this.__LOCALE_ID_45 = import0.ɵn(this.parent.get(import0.LOCALE_ID,(null as any)))); }
    return this.__LOCALE_ID_45;
  }
  get _NgLocalization_46():import3.NgLocaleLocalization {
    if ((this.__NgLocalization_46 == null)) { (this.__NgLocalization_46 = new import3.NgLocaleLocalization(this._LOCALE_ID_45)); }
    return this.__NgLocalization_46;
  }
  get _IterableDiffers_47():any {
    if ((this.__IterableDiffers_47 == null)) { (this.__IterableDiffers_47 = import0.ɵl()); }
    return this.__IterableDiffers_47;
  }
  get _KeyValueDiffers_48():any {
    if ((this.__KeyValueDiffers_48 == null)) { (this.__KeyValueDiffers_48 = import0.ɵm()); }
    return this.__KeyValueDiffers_48;
  }
  get _DomSanitizer_49():import5.ɵe {
    if ((this.__DomSanitizer_49 == null)) { (this.__DomSanitizer_49 = new import5.ɵe(this.parent.get(import5.DOCUMENT))); }
    return this.__DomSanitizer_49;
  }
  get _Sanitizer_50():any {
    if ((this.__Sanitizer_50 == null)) { (this.__Sanitizer_50 = this._DomSanitizer_49); }
    return this.__Sanitizer_50;
  }
  get _HAMMER_GESTURE_CONFIG_51():import5.HammerGestureConfig {
    if ((this.__HAMMER_GESTURE_CONFIG_51 == null)) { (this.__HAMMER_GESTURE_CONFIG_51 = new import5.HammerGestureConfig()); }
    return this.__HAMMER_GESTURE_CONFIG_51;
  }
  get _EVENT_MANAGER_PLUGINS_52():any[] {
    if ((this.__EVENT_MANAGER_PLUGINS_52 == null)) { (this.__EVENT_MANAGER_PLUGINS_52 = [
      new import5.ɵDomEventsPlugin(this.parent.get(import5.DOCUMENT)),
      new import5.ɵKeyEventsPlugin(this.parent.get(import5.DOCUMENT)),
      new import5.ɵHammerGesturesPlugin(this.parent.get(import5.DOCUMENT),this._HAMMER_GESTURE_CONFIG_51)
    ]
    ); }
    return this.__EVENT_MANAGER_PLUGINS_52;
  }
  get _EventManager_53():import5.EventManager {
    if ((this.__EventManager_53 == null)) { (this.__EventManager_53 = new import5.EventManager(this._EVENT_MANAGER_PLUGINS_52,this.parent.get(import0.NgZone))); }
    return this.__EventManager_53;
  }
  get _ɵDomSharedStylesHost_54():import5.ɵDomSharedStylesHost {
    if ((this.__ɵDomSharedStylesHost_54 == null)) { (this.__ɵDomSharedStylesHost_54 = new import5.ɵDomSharedStylesHost(this.parent.get(import5.DOCUMENT))); }
    return this.__ɵDomSharedStylesHost_54;
  }
  get _ɵDomRendererFactory2_55():import5.ɵDomRendererFactory2 {
    if ((this.__ɵDomRendererFactory2_55 == null)) { (this.__ɵDomRendererFactory2_55 = new import5.ɵDomRendererFactory2(this._EventManager_53,this._ɵDomSharedStylesHost_54)); }
    return this.__ɵDomRendererFactory2_55;
  }
  get _AnimationDriver_56():any {
    if ((this.__AnimationDriver_56 == null)) { (this.__AnimationDriver_56 = import6.ɵb()); }
    return this.__AnimationDriver_56;
  }
  get _ɵAnimationStyleNormalizer_57():any {
    if ((this.__ɵAnimationStyleNormalizer_57 == null)) { (this.__ɵAnimationStyleNormalizer_57 = import6.ɵc()); }
    return this.__ɵAnimationStyleNormalizer_57;
  }
  get _ɵAnimationEngine_58():import6.ɵa {
    if ((this.__ɵAnimationEngine_58 == null)) { (this.__ɵAnimationEngine_58 = new import6.ɵa(this._AnimationDriver_56,this._ɵAnimationStyleNormalizer_57)); }
    return this.__ɵAnimationEngine_58;
  }
  get _RendererFactory2_59():any {
    if ((this.__RendererFactory2_59 == null)) { (this.__RendererFactory2_59 = import6.ɵd(this._ɵDomRendererFactory2_55,this._ɵAnimationEngine_58,this.parent.get(import0.NgZone))); }
    return this.__RendererFactory2_59;
  }
  get _ɵSharedStylesHost_60():any {
    if ((this.__ɵSharedStylesHost_60 == null)) { (this.__ɵSharedStylesHost_60 = this._ɵDomSharedStylesHost_54); }
    return this.__ɵSharedStylesHost_60;
  }
  get _Testability_61():import0.Testability {
    if ((this.__Testability_61 == null)) { (this.__Testability_61 = new import0.Testability(this.parent.get(import0.NgZone))); }
    return this.__Testability_61;
  }
  get _Meta_62():import5.Meta {
    if ((this.__Meta_62 == null)) { (this.__Meta_62 = new import5.Meta(this.parent.get(import5.DOCUMENT))); }
    return this.__Meta_62;
  }
  get _Title_63():import5.Title {
    if ((this.__Title_63 == null)) { (this.__Title_63 = new import5.Title(this.parent.get(import5.DOCUMENT))); }
    return this.__Title_63;
  }
  get _BrowserXhr_64():import7.BrowserXhr {
    if ((this.__BrowserXhr_64 == null)) { (this.__BrowserXhr_64 = new import7.BrowserXhr()); }
    return this.__BrowserXhr_64;
  }
  get _ResponseOptions_65():import7.BaseResponseOptions {
    if ((this.__ResponseOptions_65 == null)) { (this.__ResponseOptions_65 = new import7.BaseResponseOptions()); }
    return this.__ResponseOptions_65;
  }
  get _XSRFStrategy_66():any {
    if ((this.__XSRFStrategy_66 == null)) { (this.__XSRFStrategy_66 = import7.ɵb()); }
    return this.__XSRFStrategy_66;
  }
  get _XHRBackend_67():import7.XHRBackend {
    if ((this.__XHRBackend_67 == null)) { (this.__XHRBackend_67 = new import7.XHRBackend(this._BrowserXhr_64,this._ResponseOptions_65,this._XSRFStrategy_66)); }
    return this.__XHRBackend_67;
  }
  get _RequestOptions_68():import7.BaseRequestOptions {
    if ((this.__RequestOptions_68 == null)) { (this.__RequestOptions_68 = new import7.BaseRequestOptions()); }
    return this.__RequestOptions_68;
  }
  get _Http_69():any {
    if ((this.__Http_69 == null)) { (this.__Http_69 = import7.ɵc(this._XHRBackend_67,this._RequestOptions_68)); }
    return this.__Http_69;
  }
  get _ErrorHandler_70():import23.ErrorHandler {
    if ((this.__ErrorHandler_70 == null)) { (this.__ErrorHandler_70 = new import23.ErrorHandler()); }
    return this.__ErrorHandler_70;
  }
  get _SocketDriver_71():import24.SocketBrowser {
    if ((this.__SocketDriver_71 == null)) { (this.__SocketDriver_71 = new import24.SocketBrowser()); }
    return this.__SocketDriver_71;
  }
  get _SocketConnection_72():import25.SocketConnection {
    if ((this.__SocketConnection_72 == null)) { (this.__SocketConnection_72 = new import25.SocketConnection(this._SocketDriver_71,this.parent.get(import0.NgZone))); }
    return this.__SocketConnection_72;
  }
  get _ɵi_73():import9.ɵi {
    if ((this.__ɵi_73 == null)) { (this.__ɵi_73 = new import9.ɵi()); }
    return this.__ɵi_73;
  }
  get _FormBuilder_74():import9.FormBuilder {
    if ((this.__FormBuilder_74 == null)) { (this.__FormBuilder_74 = new import9.FormBuilder()); }
    return this.__FormBuilder_74;
  }
  get _TransferHttp_75():import26.TransferHttp {
    if ((this.__TransferHttp_75 == null)) { (this.__TransferHttp_75 = new import26.TransferHttp(this._Http_69,this._TransferState_44)); }
    return this.__TransferHttp_75;
  }
  get _ActivatedRoute_76():any {
    if ((this.__ActivatedRoute_76 == null)) { (this.__ActivatedRoute_76 = import4.ɵf(this._Router_29)); }
    return this.__ActivatedRoute_76;
  }
  get _NoPreloading_77():import4.NoPreloading {
    if ((this.__NoPreloading_77 == null)) { (this.__NoPreloading_77 = new import4.NoPreloading()); }
    return this.__NoPreloading_77;
  }
  get _PreloadingStrategy_78():any {
    if ((this.__PreloadingStrategy_78 == null)) { (this.__PreloadingStrategy_78 = this._NoPreloading_77); }
    return this.__PreloadingStrategy_78;
  }
  get _RouterPreloader_79():import4.RouterPreloader {
    if ((this.__RouterPreloader_79 == null)) { (this.__RouterPreloader_79 = new import4.RouterPreloader(this._Router_29,this._NgModuleFactoryLoader_27,this._Compiler_26,this,this._PreloadingStrategy_78)); }
    return this.__RouterPreloader_79;
  }
  get _PreloadAllModules_80():import4.PreloadAllModules {
    if ((this.__PreloadAllModules_80 == null)) { (this.__PreloadAllModules_80 = new import4.PreloadAllModules()); }
    return this.__PreloadAllModules_80;
  }
  get _ROUTER_INITIALIZER_81():any {
    if ((this.__ROUTER_INITIALIZER_81 == null)) { (this.__ROUTER_INITIALIZER_81 = import4.ɵi(this._ɵg_4)); }
    return this.__ROUTER_INITIALIZER_81;
  }
  get _APP_BOOTSTRAP_LISTENER_82():any[] {
    if ((this.__APP_BOOTSTRAP_LISTENER_82 == null)) { (this.__APP_BOOTSTRAP_LISTENER_82 = [this._ROUTER_INITIALIZER_81]); }
    return this.__APP_BOOTSTRAP_LISTENER_82;
  }
  get _SDKModels_83():import27.SDKModels {
    if ((this.__SDKModels_83 == null)) { (this.__SDKModels_83 = new import27.SDKModels()); }
    return this.__SDKModels_83;
  }
  get _InternalStorage_84():import28.CookieBrowser {
    if ((this.__InternalStorage_84 == null)) { (this.__InternalStorage_84 = new import28.CookieBrowser()); }
    return this.__InternalStorage_84;
  }
  get _LoopBackAuth_85():import29.LoopBackAuth {
    if ((this.__LoopBackAuth_85 == null)) { (this.__LoopBackAuth_85 = new import29.LoopBackAuth(this._InternalStorage_84)); }
    return this.__LoopBackAuth_85;
  }
  get _JSONSearchParams_86():import30.JSONSearchParams {
    if ((this.__JSONSearchParams_86 == null)) { (this.__JSONSearchParams_86 = new import30.JSONSearchParams()); }
    return this.__JSONSearchParams_86;
  }
  get _AppUserApi_87():import31.AppUserApi {
    if ((this.__AppUserApi_87 == null)) { (this.__AppUserApi_87 = new import31.AppUserApi(this._Http_69,this._SocketConnection_72,this._SDKModels_83,this._LoopBackAuth_85,this._JSONSearchParams_86,this._ErrorHandler_70)); }
    return this.__AppUserApi_87;
  }
  get _AuthService_88():import32.AuthService {
    if ((this.__AuthService_88 == null)) { (this.__AuthService_88 = new import32.AuthService(this._AppUserApi_87)); }
    return this.__AuthService_88;
  }
  get _AxisResolverFactory_89():import33.AxisResolverFactory {
    if ((this.__AxisResolverFactory_89 == null)) { (this.__AxisResolverFactory_89 = new import33.AxisResolverFactory()); }
    return this.__AxisResolverFactory_89;
  }
  get _PositionResolverFactory_90():import34.PositionResolverFactory {
    if ((this.__PositionResolverFactory_90 == null)) { (this.__PositionResolverFactory_90 = new import34.PositionResolverFactory(this._AxisResolverFactory_89)); }
    return this.__PositionResolverFactory_90;
  }
  get _ScrollRegister_91():import35.ScrollRegister {
    if ((this.__ScrollRegister_91 == null)) { (this.__ScrollRegister_91 = new import35.ScrollRegister()); }
    return this.__ScrollRegister_91;
  }
  get _ScrollResolver_92():import36.ScrollResolver {
    if ((this.__ScrollResolver_92 == null)) { (this.__ScrollResolver_92 = new import36.ScrollResolver()); }
    return this.__ScrollResolver_92;
  }
  get _PageApi_93():import37.PageApi {
    if ((this.__PageApi_93 == null)) { (this.__PageApi_93 = new import37.PageApi(this._Http_69,this._SocketConnection_72,this._SDKModels_83,this._LoopBackAuth_85,this._JSONSearchParams_86,this._ErrorHandler_70)); }
    return this.__PageApi_93;
  }
  get _ArticleApi_94():import38.ArticleApi {
    if ((this.__ArticleApi_94 == null)) { (this.__ArticleApi_94 = new import38.ArticleApi(this._Http_69,this._SocketConnection_72,this._SDKModels_83,this._LoopBackAuth_85,this._JSONSearchParams_86,this._ErrorHandler_70)); }
    return this.__ArticleApi_94;
  }
  get _StringUtils_95():import39.StringUtils {
    if ((this.__StringUtils_95 == null)) { (this.__StringUtils_95 = new import39.StringUtils()); }
    return this.__StringUtils_95;
  }
  get _ArticleUtils_96():import40.ArticleUtils {
    if ((this.__ArticleUtils_96 == null)) { (this.__ArticleUtils_96 = new import40.ArticleUtils(this._PageApi_93,this._ArticleApi_94,this._StringUtils_95)); }
    return this.__ArticleUtils_96;
  }
  get _CostGuideApi_97():import41.CostGuideApi {
    if ((this.__CostGuideApi_97 == null)) { (this.__CostGuideApi_97 = new import41.CostGuideApi(this._Http_69,this._SocketConnection_72,this._SDKModels_83,this._LoopBackAuth_85,this._JSONSearchParams_86,this._ErrorHandler_70)); }
    return this.__CostGuideApi_97;
  }
  get _CategoryApi_98():import42.CategoryApi {
    if ((this.__CategoryApi_98 == null)) { (this.__CategoryApi_98 = new import42.CategoryApi(this._Http_69,this._SocketConnection_72,this._SDKModels_83,this._LoopBackAuth_85,this._JSONSearchParams_86,this._ErrorHandler_70)); }
    return this.__CategoryApi_98;
  }
  get _ZipcodeModificationFactorApi_99():import43.ZipcodeModificationFactorApi {
    if ((this.__ZipcodeModificationFactorApi_99 == null)) { (this.__ZipcodeModificationFactorApi_99 = new import43.ZipcodeModificationFactorApi(this._Http_69,this._SocketConnection_72,this._SDKModels_83,this._LoopBackAuth_85,this._JSONSearchParams_86,this._ErrorHandler_70)); }
    return this.__ZipcodeModificationFactorApi_99;
  }
  get _CostGuideUtils_100():import44.CostGuideUtils {
    if ((this.__CostGuideUtils_100 == null)) { (this.__CostGuideUtils_100 = new import44.CostGuideUtils(this._PageApi_93,this._CostGuideApi_97,this._CategoryApi_98,this._ZipcodeModificationFactorApi_99)); }
    return this.__CostGuideUtils_100;
  }
  get _DynamicTypeBuilder_101():import45.DynamicTypeBuilder {
    if ((this.__DynamicTypeBuilder_101 == null)) { (this.__DynamicTypeBuilder_101 = new import45.DynamicTypeBuilder(this.componentFactoryResolver,this)); }
    return this.__DynamicTypeBuilder_101;
  }
  get _HeroAnimationService_103():import46.HeroAnimationService {
    if ((this.__HeroAnimationService_103 == null)) { (this.__HeroAnimationService_103 = new import46.HeroAnimationService(this._isBrowser_102)); }
    return this.__HeroAnimationService_103;
  }
  get _CityApi_104():import47.CityApi {
    if ((this.__CityApi_104 == null)) { (this.__CityApi_104 = new import47.CityApi(this._Http_69,this._SocketConnection_72,this._SDKModels_83,this._LoopBackAuth_85,this._JSONSearchParams_86,this._ErrorHandler_70)); }
    return this.__CityApi_104;
  }
  get _CityUtils_105():import48.CityUtils {
    if ((this.__CityUtils_105 == null)) { (this.__CityUtils_105 = new import48.CityUtils(this._CityApi_104)); }
    return this.__CityUtils_105;
  }
  get _ProfessionCategoryApi_106():import49.ProfessionCategoryApi {
    if ((this.__ProfessionCategoryApi_106 == null)) { (this.__ProfessionCategoryApi_106 = new import49.ProfessionCategoryApi(this._Http_69,this._SocketConnection_72,this._SDKModels_83,this._LoopBackAuth_85,this._JSONSearchParams_86,this._ErrorHandler_70)); }
    return this.__ProfessionCategoryApi_106;
  }
  get _ProfessionCategoriesUtils_107():import50.ProfessionCategoriesUtils {
    if ((this.__ProfessionCategoriesUtils_107 == null)) { (this.__ProfessionCategoriesUtils_107 = new import50.ProfessionCategoriesUtils(this._ProfessionCategoryApi_106)); }
    return this.__ProfessionCategoriesUtils_107;
  }
  get _MapUrlUtils_108():import51.MapUrlUtils {
    if ((this.__MapUrlUtils_108 == null)) { (this.__MapUrlUtils_108 = new import51.MapUrlUtils()); }
    return this.__MapUrlUtils_108;
  }
  get _CensusTractsTilesUtils_109():import52.CensusTractsTilesUtils {
    if ((this.__CensusTractsTilesUtils_109 == null)) { (this.__CensusTractsTilesUtils_109 = new import52.CensusTractsTilesUtils(this._Http_69,this._TransferState_44)); }
    return this.__CensusTractsTilesUtils_109;
  }
  get _CostsOfLivingApi_110():import53.CostsOfLivingApi {
    if ((this.__CostsOfLivingApi_110 == null)) { (this.__CostsOfLivingApi_110 = new import53.CostsOfLivingApi(this._Http_69,this._SocketConnection_72,this._SDKModels_83,this._LoopBackAuth_85,this._JSONSearchParams_86,this._ErrorHandler_70)); }
    return this.__CostsOfLivingApi_110;
  }
  get _CostOfLivingUtils_111():import54.CostOfLivingUtils {
    if ((this.__CostOfLivingUtils_111 == null)) { (this.__CostOfLivingUtils_111 = new import54.CostOfLivingUtils(this._CostsOfLivingApi_110)); }
    return this.__CostOfLivingUtils_111;
  }
  get _TaxesApi_112():import55.TaxesApi {
    if ((this.__TaxesApi_112 == null)) { (this.__TaxesApi_112 = new import55.TaxesApi(this._Http_69,this._SocketConnection_72,this._SDKModels_83,this._LoopBackAuth_85,this._JSONSearchParams_86,this._ErrorHandler_70)); }
    return this.__TaxesApi_112;
  }
  get _TaxesUtils_113():import56.TaxesUtils {
    if ((this.__TaxesUtils_113 == null)) { (this.__TaxesUtils_113 = new import56.TaxesUtils(this._Http_69,this._TaxesApi_112)); }
    return this.__TaxesUtils_113;
  }
  get _AffordabilityUtils_114():import57.AffordabilityUtils {
    if ((this.__AffordabilityUtils_114 == null)) { (this.__AffordabilityUtils_114 = new import57.AffordabilityUtils(this._Http_69,this._TransferState_44,this._CostOfLivingUtils_111,this._TaxesUtils_113)); }
    return this.__AffordabilityUtils_114;
  }
  get _Aot2JitSharingService_115():import58.Aot2JitSharingService {
    if ((this.__Aot2JitSharingService_115 == null)) { (this.__Aot2JitSharingService_115 = new import58.Aot2JitSharingService()); }
    return this.__Aot2JitSharingService_115;
  }
  get _LoggerService_116():import59.LoggerService {
    if ((this.__LoggerService_116 == null)) { (this.__LoggerService_116 = new import59.LoggerService()); }
    return this.__LoggerService_116;
  }
  get _RealTime_117():import60.RealTime {
    if ((this.__RealTime_117 == null)) { (this.__RealTime_117 = new import60.RealTime(this._SocketConnection_72,this._SDKModels_83,this._LoopBackAuth_85)); }
    return this.__RealTime_117;
  }
  get _FixrAPIApi_118():import61.FixrAPIApi {
    if ((this.__FixrAPIApi_118 == null)) { (this.__FixrAPIApi_118 = new import61.FixrAPIApi(this._Http_69,this._SocketConnection_72,this._SDKModels_83,this._LoopBackAuth_85,this._JSONSearchParams_86,this._ErrorHandler_70)); }
    return this.__FixrAPIApi_118;
  }
  get _ProfessionAnnualWagesIndexApi_119():import62.ProfessionAnnualWagesIndexApi {
    if ((this.__ProfessionAnnualWagesIndexApi_119 == null)) { (this.__ProfessionAnnualWagesIndexApi_119 = new import62.ProfessionAnnualWagesIndexApi(this._Http_69,this._SocketConnection_72,this._SDKModels_83,this._LoopBackAuth_85,this._JSONSearchParams_86,this._ErrorHandler_70)); }
    return this.__ProfessionAnnualWagesIndexApi_119;
  }
  get _JobApi_120():import63.JobApi {
    if ((this.__JobApi_120 == null)) { (this.__JobApi_120 = new import63.JobApi(this._Http_69,this._SocketConnection_72,this._SDKModels_83,this._LoopBackAuth_85,this._JSONSearchParams_86,this._ErrorHandler_70)); }
    return this.__JobApi_120;
  }
  get _TaxSimApi_121():import64.TaxSimApi {
    if ((this.__TaxSimApi_121 == null)) { (this.__TaxSimApi_121 = new import64.TaxSimApi(this._Http_69,this._SocketConnection_72,this._SDKModels_83,this._LoopBackAuth_85,this._JSONSearchParams_86,this._ErrorHandler_70)); }
    return this.__TaxSimApi_121;
  }
  get _SDKStorage_122():import65.StorageBrowser {
    if ((this.__SDKStorage_122 == null)) { (this.__SDKStorage_122 = new import65.StorageBrowser()); }
    return this.__SDKStorage_122;
  }
  createInternal():import1.BrowserAppModule {
    this._BrowserTransferStateModule_0 = new import2.BrowserTransferStateModule();
    this._CommonModule_1 = new import3.CommonModule();
    this._ErrorHandler_2 = import5.ɵa();
    this._NgProbeToken_3 = [import4.ɵb()];
    this._ɵg_4 = new import4.ɵg(this);
    this._APP_ID_5 = 'howmuch';
    this._ɵTRANSITION_ID_6 = this._APP_ID_5;
    this._APP_INITIALIZER_7 = [
      import0.ɵo,
      import5.ɵc(this.parent.get(import5.NgProbeToken,(null as any)),this._NgProbeToken_3),
      import4.ɵh(this._ɵg_4),
      import5.ɵf(this._ɵTRANSITION_ID_6,this.parent.get(import5.DOCUMENT),this)
    ]
    ;
    this._ApplicationInitStatus_8 = new import0.ApplicationInitStatus(this._APP_INITIALIZER_7);
    this._ɵf_9 = new import0.ɵf(this.parent.get(import0.NgZone),this.parent.get(import0.ɵConsole),this,this._ErrorHandler_2,this.componentFactoryResolver,this._ApplicationInitStatus_8);
    this._ApplicationRef_10 = this._ɵf_9;
    this._ApplicationModule_11 = new import0.ApplicationModule(this._ApplicationRef_10);
    this._BrowserModule_12 = new import5.BrowserModule(this.parent.get(import5.BrowserModule,(null as any)));
    this._BrowserAnimationsModule_13 = new import6.BrowserAnimationsModule();
    this._HttpModule_14 = new import7.HttpModule();
    this._SDKBrowserModule_15 = new import8.SDKBrowserModule();
    this._ɵba_16 = new import9.ɵba();
    this._FormsModule_17 = new import9.FormsModule();
    this._ReactiveFormsModule_18 = new import9.ReactiveFormsModule();
    this._TransferHttpModule_19 = new import10.TransferHttpModule();
    this._ɵa_20 = import4.ɵd(this.parent.get(import4.Router,(null as any)));
    this._UrlSerializer_21 = new import4.DefaultUrlSerializer();
    this._RouterOutletMap_22 = new import4.RouterOutletMap();
    this._ROUTER_CONFIGURATION_23 = {};
    this._LocationStrategy_24 = import4.ɵc(this.parent.get(import3.PlatformLocation),this.parent.get(import3.APP_BASE_HREF,(null as any)),this._ROUTER_CONFIGURATION_23);
    this._Location_25 = new import3.Location(this._LocationStrategy_24);
    this._Compiler_26 = new import0.Compiler();
    this._NgModuleFactoryLoader_27 = new import0.SystemJsNgModuleLoader(this._Compiler_26,this.parent.get(import0.SystemJsNgModuleLoaderConfig,(null as any)));
      this._ROUTES_28 = [[
        {
          path: '',
          component: import76.HomeComponent,
          pathMatch: 'full'
        }
        ,
        {
          path: 'cost-guides',
          component: import77.CostGuideListComponent,
          pathMatch: 'full'
        }
        ,
        {
          path: 'costs/:seoId',
          component: import78.CostGuideComponent,
          pathMatch: 'full'
        }
        ,
        {
          path: 'articles/:seoId',
          component: import79.ArticleComponent,
          pathMatch: 'full'
        }
        ,
        {
          path: 'sources/:seoId',
          component: import79.ArticleComponent,
          pathMatch: 'full'
        }
        ,
        {
          path: 'privacy-policy.html',
          component: import79.ArticleComponent,
          pathMatch: 'full'
        }
        ,
        {
          path: 'terms-of-use.html',
          component: import79.ArticleComponent,
          pathMatch: 'full'
        }
        ,
        {
          path: 'economy',
          component: import80.CategoryComponent,
          pathMatch: 'full'
        }
        ,
        {
          path: 'personal-finance',
          component: import80.CategoryComponent,
          pathMatch: 'full'
        }
        ,
        {
          path: 'remodeling-form/:formId',
          component: import81.QuestionnaireFormComponent,
          pathMatch: 'full'
        }
        ,
        {
          path: 'remodeling-form-success',
          component: import82.SuccessPageComponent,
          pathMatch: 'full'
        }
        ,
        {
          path: 'insurance-form/:formId',
          component: import81.QuestionnaireFormComponent,
          pathMatch: 'full'
        }
        ,
        {
          path: 'insurance-form-success',
          component: import82.SuccessPageComponent,
          pathMatch: 'full'
        }
        ,
        {
          path: 'business',
          component: import80.CategoryComponent,
          pathMatch: 'full'
        }
        ,
        {
          path: 'real-estate',
          component: import80.CategoryComponent,
          pathMatch: 'full'
        }
        ,
        {
          path: 'about-us.html',
          component: import83.AboutUsComponent,
          pathMatch: 'full'
        }
        ,
        {
          path: 'cost-of-living/:state/:city',
          component: import84.CostOfLivingComponent,
          pathMatch: 'full'
        }
        ,
        {
          path: 'cost-of-living/:state/:city/',
          component: import84.CostOfLivingComponent,
          pathMatch: 'full'
        }

      ]
    ];
    this._Router_29 = import4.ɵe(this._ApplicationRef_10,this._UrlSerializer_21,this._RouterOutletMap_22,this._Location_25,this,this._NgModuleFactoryLoader_27,this._Compiler_26,this._ROUTES_28,this._ROUTER_CONFIGURATION_23,this.parent.get(import4.UrlHandlingStrategy,(null as any)),this.parent.get(import4.RouteReuseStrategy,(null as any)));
    this._RouterModule_30 = new import4.RouterModule(this._ɵa_20,this._Router_29);
    this._AppRoutingModule_31 = new import11.AppRoutingModule();
    this._LoginModule_32 = new import12.LoginModule();
    this._SocialShareModule_33 = new import13.SocialShareModule();
    this._DecoratorModule_34 = new import14.DecoratorModule();
    this._DisqusModule_35 = new import15.DisqusModule();
    this._StickyHeaderModule_36 = new import16.StickyHeaderModule();
    this._InfiniteScrollModule_37 = new import17.InfiniteScrollModule();
    this._SubscribeModule_38 = new import18.SubscribeModule();
    this._UnescapeCachePipeModule_39 = new import19.UnescapeCachePipeModule();
    this._SectionCategoryModule_40 = new import20.SectionCategoryModule();
    this._NouisliderModule_41 = new import21.NouisliderModule();
    this._AppModule_42 = new import22.AppModule();
    this._BrowserAppModule_43 = new import1.BrowserAppModule();
    this._isBrowser_102 = true;
    this._isNode_123 = false;
    return this._BrowserAppModule_43;
  }
  getInternal(token:any,notFoundResult:any):any {
    if ((token === import2.BrowserTransferStateModule)) { return this._BrowserTransferStateModule_0; }
    if ((token === import3.CommonModule)) { return this._CommonModule_1; }
    if ((token === import0.ErrorHandler)) { return this._ErrorHandler_2; }
    if ((token === import0.NgProbeToken)) { return this._NgProbeToken_3; }
    if ((token === import4.ɵg)) { return this._ɵg_4; }
    if ((token === import0.APP_ID)) { return this._APP_ID_5; }
    if ((token === import5.ɵTRANSITION_ID)) { return this._ɵTRANSITION_ID_6; }
    if ((token === import0.APP_INITIALIZER)) { return this._APP_INITIALIZER_7; }
    if ((token === import0.ApplicationInitStatus)) { return this._ApplicationInitStatus_8; }
    if ((token === import0.ɵf)) { return this._ɵf_9; }
    if ((token === import0.ApplicationRef)) { return this._ApplicationRef_10; }
    if ((token === import0.ApplicationModule)) { return this._ApplicationModule_11; }
    if ((token === import5.BrowserModule)) { return this._BrowserModule_12; }
    if ((token === import6.BrowserAnimationsModule)) { return this._BrowserAnimationsModule_13; }
    if ((token === import7.HttpModule)) { return this._HttpModule_14; }
    if ((token === import8.SDKBrowserModule)) { return this._SDKBrowserModule_15; }
    if ((token === import9.ɵba)) { return this._ɵba_16; }
    if ((token === import9.FormsModule)) { return this._FormsModule_17; }
    if ((token === import9.ReactiveFormsModule)) { return this._ReactiveFormsModule_18; }
    if ((token === import10.TransferHttpModule)) { return this._TransferHttpModule_19; }
    if ((token === import4.ɵa)) { return this._ɵa_20; }
    if ((token === import4.UrlSerializer)) { return this._UrlSerializer_21; }
    if ((token === import4.RouterOutletMap)) { return this._RouterOutletMap_22; }
    if ((token === import4.ROUTER_CONFIGURATION)) { return this._ROUTER_CONFIGURATION_23; }
    if ((token === import3.LocationStrategy)) { return this._LocationStrategy_24; }
    if ((token === import3.Location)) { return this._Location_25; }
    if ((token === import0.Compiler)) { return this._Compiler_26; }
    if ((token === import0.NgModuleFactoryLoader)) { return this._NgModuleFactoryLoader_27; }
    if ((token === import4.ROUTES)) { return this._ROUTES_28; }
    if ((token === import4.Router)) { return this._Router_29; }
    if ((token === import4.RouterModule)) { return this._RouterModule_30; }
    if ((token === import11.AppRoutingModule)) { return this._AppRoutingModule_31; }
    if ((token === import12.LoginModule)) { return this._LoginModule_32; }
    if ((token === import13.SocialShareModule)) { return this._SocialShareModule_33; }
    if ((token === import14.DecoratorModule)) { return this._DecoratorModule_34; }
    if ((token === import15.DisqusModule)) { return this._DisqusModule_35; }
    if ((token === import16.StickyHeaderModule)) { return this._StickyHeaderModule_36; }
    if ((token === import17.InfiniteScrollModule)) { return this._InfiniteScrollModule_37; }
    if ((token === import18.SubscribeModule)) { return this._SubscribeModule_38; }
    if ((token === import19.UnescapeCachePipeModule)) { return this._UnescapeCachePipeModule_39; }
    if ((token === import20.SectionCategoryModule)) { return this._SectionCategoryModule_40; }
    if ((token === import21.NouisliderModule)) { return this._NouisliderModule_41; }
    if ((token === import22.AppModule)) { return this._AppModule_42; }
    if ((token === import1.BrowserAppModule)) { return this._BrowserAppModule_43; }
    if ((token === import85.TransferState)) { return this._TransferState_44; }
    if ((token === import0.LOCALE_ID)) { return this._LOCALE_ID_45; }
    if ((token === import3.NgLocalization)) { return this._NgLocalization_46; }
    if ((token === import0.IterableDiffers)) { return this._IterableDiffers_47; }
    if ((token === import0.KeyValueDiffers)) { return this._KeyValueDiffers_48; }
    if ((token === import5.DomSanitizer)) { return this._DomSanitizer_49; }
    if ((token === import0.Sanitizer)) { return this._Sanitizer_50; }
    if ((token === import5.HAMMER_GESTURE_CONFIG)) { return this._HAMMER_GESTURE_CONFIG_51; }
    if ((token === import5.EVENT_MANAGER_PLUGINS)) { return this._EVENT_MANAGER_PLUGINS_52; }
    if ((token === import5.EventManager)) { return this._EventManager_53; }
    if ((token === import5.ɵDomSharedStylesHost)) { return this._ɵDomSharedStylesHost_54; }
    if ((token === import5.ɵDomRendererFactory2)) { return this._ɵDomRendererFactory2_55; }
    if ((token === import86.AnimationDriver)) { return this._AnimationDriver_56; }
    if ((token === import86.ɵAnimationStyleNormalizer)) { return this._ɵAnimationStyleNormalizer_57; }
    if ((token === import86.ɵAnimationEngine)) { return this._ɵAnimationEngine_58; }
    if ((token === import0.RendererFactory2)) { return this._RendererFactory2_59; }
    if ((token === import5.ɵSharedStylesHost)) { return this._ɵSharedStylesHost_60; }
    if ((token === import0.Testability)) { return this._Testability_61; }
    if ((token === import5.Meta)) { return this._Meta_62; }
    if ((token === import5.Title)) { return this._Title_63; }
    if ((token === import7.BrowserXhr)) { return this._BrowserXhr_64; }
    if ((token === import7.ResponseOptions)) { return this._ResponseOptions_65; }
    if ((token === import7.XSRFStrategy)) { return this._XSRFStrategy_66; }
    if ((token === import7.XHRBackend)) { return this._XHRBackend_67; }
    if ((token === import7.RequestOptions)) { return this._RequestOptions_68; }
    if ((token === import7.Http)) { return this._Http_69; }
    if ((token === import23.ErrorHandler)) { return this._ErrorHandler_70; }
    if ((token === import87.SocketDriver)) { return this._SocketDriver_71; }
    if ((token === import25.SocketConnection)) { return this._SocketConnection_72; }
    if ((token === import9.ɵi)) { return this._ɵi_73; }
    if ((token === import9.FormBuilder)) { return this._FormBuilder_74; }
    if ((token === import26.TransferHttp)) { return this._TransferHttp_75; }
    if ((token === import4.ActivatedRoute)) { return this._ActivatedRoute_76; }
    if ((token === import4.NoPreloading)) { return this._NoPreloading_77; }
    if ((token === import4.PreloadingStrategy)) { return this._PreloadingStrategy_78; }
    if ((token === import4.RouterPreloader)) { return this._RouterPreloader_79; }
    if ((token === import4.PreloadAllModules)) { return this._PreloadAllModules_80; }
    if ((token === import4.ROUTER_INITIALIZER)) { return this._ROUTER_INITIALIZER_81; }
    if ((token === import0.APP_BOOTSTRAP_LISTENER)) { return this._APP_BOOTSTRAP_LISTENER_82; }
    if ((token === import27.SDKModels)) { return this._SDKModels_83; }
    if ((token === import88.InternalStorage)) { return this._InternalStorage_84; }
    if ((token === import29.LoopBackAuth)) { return this._LoopBackAuth_85; }
    if ((token === import30.JSONSearchParams)) { return this._JSONSearchParams_86; }
    if ((token === import31.AppUserApi)) { return this._AppUserApi_87; }
    if ((token === import32.AuthService)) { return this._AuthService_88; }
    if ((token === import33.AxisResolverFactory)) { return this._AxisResolverFactory_89; }
    if ((token === import34.PositionResolverFactory)) { return this._PositionResolverFactory_90; }
    if ((token === import35.ScrollRegister)) { return this._ScrollRegister_91; }
    if ((token === import36.ScrollResolver)) { return this._ScrollResolver_92; }
    if ((token === import37.PageApi)) { return this._PageApi_93; }
    if ((token === import38.ArticleApi)) { return this._ArticleApi_94; }
    if ((token === import39.StringUtils)) { return this._StringUtils_95; }
    if ((token === import40.ArticleUtils)) { return this._ArticleUtils_96; }
    if ((token === import41.CostGuideApi)) { return this._CostGuideApi_97; }
    if ((token === import42.CategoryApi)) { return this._CategoryApi_98; }
    if ((token === import43.ZipcodeModificationFactorApi)) { return this._ZipcodeModificationFactorApi_99; }
    if ((token === import44.CostGuideUtils)) { return this._CostGuideUtils_100; }
    if ((token === import45.DynamicTypeBuilder)) { return this._DynamicTypeBuilder_101; }
    if ((token === 'isBrowser')) { return this._isBrowser_102; }
    if ((token === import46.HeroAnimationService)) { return this._HeroAnimationService_103; }
    if ((token === import47.CityApi)) { return this._CityApi_104; }
    if ((token === import48.CityUtils)) { return this._CityUtils_105; }
    if ((token === import49.ProfessionCategoryApi)) { return this._ProfessionCategoryApi_106; }
    if ((token === import50.ProfessionCategoriesUtils)) { return this._ProfessionCategoriesUtils_107; }
    if ((token === import51.MapUrlUtils)) { return this._MapUrlUtils_108; }
    if ((token === import52.CensusTractsTilesUtils)) { return this._CensusTractsTilesUtils_109; }
    if ((token === import53.CostsOfLivingApi)) { return this._CostsOfLivingApi_110; }
    if ((token === import54.CostOfLivingUtils)) { return this._CostOfLivingUtils_111; }
    if ((token === import55.TaxesApi)) { return this._TaxesApi_112; }
    if ((token === import56.TaxesUtils)) { return this._TaxesUtils_113; }
    if ((token === import57.AffordabilityUtils)) { return this._AffordabilityUtils_114; }
    if ((token === import58.Aot2JitSharingService)) { return this._Aot2JitSharingService_115; }
    if ((token === import59.LoggerService)) { return this._LoggerService_116; }
    if ((token === import60.RealTime)) { return this._RealTime_117; }
    if ((token === import61.FixrAPIApi)) { return this._FixrAPIApi_118; }
    if ((token === import62.ProfessionAnnualWagesIndexApi)) { return this._ProfessionAnnualWagesIndexApi_119; }
    if ((token === import63.JobApi)) { return this._JobApi_120; }
    if ((token === import64.TaxSimApi)) { return this._TaxSimApi_121; }
    if ((token === import88.SDKStorage)) { return this._SDKStorage_122; }
    if ((token === 'isNode')) { return this._isNode_123; }
    return notFoundResult;
  }
  destroyInternal():void {
    this._ɵf_9.ngOnDestroy();
    (this.__ɵDomSharedStylesHost_54 && this._ɵDomSharedStylesHost_54.ngOnDestroy());
    (this.__RouterPreloader_79 && this._RouterPreloader_79.ngOnDestroy());
  }
}
export const BrowserAppModuleNgFactory:import0.NgModuleFactory<import1.BrowserAppModule> = new import0.NgModuleFactory<any>(BrowserAppModuleInjector,import1.BrowserAppModule);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9idWlsZC9ob3dtdWNoL3NyYy9hcHAvYnJvd3Nlci1hcHAubW9kdWxlLm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci9idWlsZC9ob3dtdWNoL3NyYy9hcHAvYnJvd3Nlci1hcHAubW9kdWxlLnRzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/ngfactory/app/browser-app.module.ngfactory.ts